import { Link } from 'react-router-dom';
import React from "react";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";
import { useEffect, useState } from "react";
import Slider from 'react-slick';

const settings = {
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 2400,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
  infinite: true,
  centerMode: true,
  centerPadding: '0',
  arrows: true,
  dots: false,
  prevArrow: (
    <button className="slick-arrow slick-prev" aria-label="Previous Slide">
      <i className="fa-solid fa-arrow-left"></i>
    </button>
  ),
  nextArrow: (
    <button className="slick-arrow slick-next" aria-label="Next Slide">
      <i className="fa-solid fa-arrow-right"></i>
    </button>
  ),


  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 769,
      settings: { slidesToShow: 2, centerPadding: '10px' },
    },


    {
      breakpoint: 600,
      settings: { slidesToShow: 1, centerPadding: '10px' },
    },
  ],
};

// const blogData = [
//   {
//     img: "/assets/images/insights-logo1.webp",
//     min: "8 Min",
//     date: "26-Oct-2025",
//     title: "Smart Waste Solutions: Why Renting a Dumpster Makes Cleanup Easy",
//     desc: "Make waste removal simple and efficient with smart dumpster rental solutions that save time and reduce hassle.",
//     link: "",
//   },
//   {
//     img: "/assets/images/insights-logo1.webp",
//     min: "5 Min",
//     date: "12-Nov-2025",
//     title: "Efficient Construction Waste Handling for Contractors",
//     desc: "Discover smart strategies to manage construction debris with cost-effective dumpster rental options.",
//     link: "",
//   },
//   {
//     img: "/assets/images/insights-logo1.webp",
//     min: "10 Min",
//     date: "05-Dec-2025",
//     title: "Top 5 Ways Dumpster Rentals Support Eco-Friendly Projects",
//     desc: "Learn how dumpsters help in recycling and reducing landfill waste in major projects.",
//     link: "",
//   },
//   {
//     img: "/assets/images/insights-logo1.webp",
//     min: "7 Min",
//     date: "14-Jan-2026",
//     title: "Residential Cleanups Made Easy with Quick Dumpster Rentals",
//     desc: "Perfect for home renovations, cleanup drives, and decluttering needs.",
//     link: "",
//   },
// ];

export default function HomeInsight({ initialData }) {
  const [allData, setAllData] = useState(Array.isArray(initialData) ? initialData : []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, {
        method: 'GET',
      });

      const result = await response.json();

      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }

  return (
    <section className="blog-section space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="services-text">
              <h2 className="heading">Explore our latest and useful Articles</h2>
            </div>
          </div>
        </div>

        <div className="wrapper">
          <Slider className="blog-slider" {...settings}>
            {Array.isArray(allData) && allData.map((item, index) => (
              <div className="outer-wrapper" key={index}>
                <div className="blog-img-wrapper">
                  <Link to={`/blogs/${item?.slug}/`} >
                    <img src={item?.thumbnail ? `${BaseUrl}${ item?.thumbnail}` : ""} className="img-responsive blog-img" alt={item.alt_thumbnail} loading="lazy" />
                  </Link>
                </div>
                <div className="main-content">
                  <div className="outer-date">
                    <span className="home-blog-min">{`${Math.round(item?.description1?.length / 200)} Min`}</span>
                    <span className="home-blog-date">{DateConvert(item?.date)}</span>
                  </div>
                  <label className="home-blog-title">{item?.title?.slice(0, 40) + "..."}</label>
                  <p>{item?.brief?.slice(0, 75) + "..."}</p>
                  <Link className="univarsal-link" to={`/blogs/${item?.slug}/`} >
                    <small>  Read More   <i className="fa-solid fa-arrow-right"></i></small>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>

          <div className="home-blog-cta text-center">
            <div className="default-btn reverse-btn">
              <Link to="/blogs/" className="theme-btn">  <span className="color-overlay"></span> <span className="btn-txt">view all</span></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
